import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import Buttons from "../../components/Button/Button";

export const Button = styled(Buttons)`
  &.google {
    background-color: #4285f4;
  }

  &.facebook {
    background-color: #4267b2;
    margin-bottom: 10px;
  }
`;

export const Wrapper = styled.div`
  text-align: center;
  background-color: #fff;
  border-radius: calc(0.3rem - 1px);
`;

export const Container = styled.div`
  padding: 0px 50px 0;
  overflow: hidden;

  .nav-tabs {
    .nav-link {
      color: #dee2e6;
      transition: color 0.2s ease;
      border-top-left-radius: calc(0.3rem - 1px);
      border-top-right-radius: calc(0.3rem - 1px);
  
      &:hover {
        color: #9cc54b;
      }
  
      &.active {
        background: #9cc54b;
        color: #ffffff;
      }
    }

    &.express {
      .nav-link {
        &:hover {
          color: #f01266;
        }
        &.active {
          background: #f01266;
          color: #ffffff;
        }
      }
    }
  }

  .tab-content {
    padding: 10px 0 !important;

    // Select input
    .css-2b097c-container {
      height: 48px !important;
      
      .css-yk16xz-control {
        height: 48px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f7f7f7 !important;
        border-color: #f1f1f1 !important;
      }

      .css-1pahdxg-control {
        border-color: #9cc54b !important;
        box-shadow: none !important;
      }

      .css-b8ldur-Input {
        display: flex;
        align-items: center;
        text-align: start;
      }

      &.express {
        .css-1pahdxg-control {
          border-color: #f01266 !important;
        }
      }
    }
  }


  @media (max-width: 768px) {
    padding: 40px 30px 0;
  }
`;

export const LogoWrapper = styled.div`
  margin-bottom: 30px;

  img {
    max-width: 160px;
  }
`;

export const Heading = styled.h3`
  color: ${themeGet("colors.primary", "#9cc54b")};
  margin-bottom: 10px;
  font-family: "Poppins", sans-serif;
  font-size: ${themeGet("fontSizes.4", "21")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  
  &.express { color: #f01266; }
`;

export const SubHeading = styled.span`
  margin-bottom: 30px;
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798c")};
  display: block;
`;

export const OfferSection = styled.div`
  padding: 20px;
  background-color: ${themeGet("colors.lightColor", "#F7F7F7")};
  color: ${themeGet("colors.primary", "#9cc54b")};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Offer = styled.p`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  margin: 0;
  
  &.express { color: #f01266; }

  .count-down {
    font-size: 1.5rem;
    color: red;
    margin-top: -1rem;
    position: relative;
    z-index:  999;
  }
`;

export const HelperText = styled.p`
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.1", "13")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkRegular", "#77798c")};
  margin: 0;
  text-align: center;
  width: 100%;

  a {
    font-weight: 700;
    color: #4285f4;
    text-decoration: underline;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 6px;
  background-color: ${themeGet("colors.lightColor", "#F7F7F7")};
  border: 1px solid ${themeGet("colors.borderColor", "#E6E6E6")};
  font-family: "Lato", sans-serif;
  font-size: ${themeGet("fontSizes.2", "15")}px;
  font-weight: ${themeGet("fontWeights.3", "400")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
  line-height: 19px;
  padding: 0 18px;
  box-sizing: border-box;
  transition: border-color 0.25s ease;
  // margin-bottom: 10px;

  &:hover,
  &:focus {
    outline: 0;
  }

  &:focus {
    border-color: ${themeGet("colors.primary", "#9cc54b")};
  }

  &.express:focus {
    border-color: #f01266;
  }

  &::placeholder {
    color: ${themeGet("colors.darkRegular", "#77798c")};
    font-size: 14px;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &.disabled {
    .inner-wrap {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;

export const Divider = styled.div`
  padding: 15px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  span {
    font-family: "Lato", sans-serif;
    font-size: ${themeGet("fontSizes.2", "15")}px;
    font-weight: ${themeGet("fontWeights.3", "400")};
    color: ${themeGet("colors.darkBold", "#0D1136")};
    line-height: 1;
    background-color: #fff;
    z-index: 0;
    position: relative;
    padding: 0 10px;
  }

  &::before {
    content: "";
    width: 100%;
    height: 1px;
    background-color: ${themeGet("colors.borderColor", "#E6E6E6")};
    position: absolute;
    top: 50%;
  }
`;

export const LinkButton = styled.button`
  background-color: transparent;
  border: 0;
  outline: 0;
  box-shadow: none;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${themeGet("colors.primary", "#9cc54b")};
  text-decoration: underline;
  cursor: pointer;
  
  &.express { color: #f01266; }
`;

export const CheckBoxWrapperR = styled.div`
  float: left;
  margin: 10px 0px 0px 0px;
`;

export const CheckBoxWrapperP = styled.div`
  float: left;
  margin: 0px 0px 7px 0px; ;
`;

export const Suggestion = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;

  .title {
    display: block;
    font-size: 1rem;
    font-weight: 700;
    text-align: center;
    // text-transform: capitalize;
  }
`;


export const StoreLogosWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-block-end: 10px;

  img {
    display: block;
    width: 200px;
    object-fit: contain;

    &.app-store {
      width: 160px;
      padding-inline-start: 10px;
    }
  }
`;

export const OtpFooterContainer = styled.footer`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	height: 60px;

  button {
    display: block;
    padding: 4px 8px;
    border-radius: 4px;
    border: none;
    outline-color: transparent;
    background: #9cc54b;
    color: #ffffff;
  }

	span {
		color: #9cc54b;
	}

	&::after {
		content: "";
		position: absolute;
		top: 0;
		width: 100%;
		height: 1px;
		background: #dee2e6;
		box-shadow: 0 0 0 100vmax #dee2e6;
		clip-path: inset(0 -100vmax);
	}

  &.express {
    button {
      background: #f01266;
    }

    span {
      color: #f01266;
    }
  }
`;

export const SuccessContainer = styled.div`
	box-sizing: border-box;
	width: 100%;
	height: 474px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 1rem;
	background: #ffffff;
	padding-top: 4rem;
  border-radius: calc(0.3rem - 1px);
`;

export const Circle = styled.div`
	width: 78px;
	height: 78px;
	border-radius: 50%;
	display: grid;
	place-items: center;
	background: #9cc54b;

	.check {
		color: #ffffff;
		font-size: 3.75rem;
	}

  &.express {
    background: #f01266;
  }
`;

export const SuccessTitle = styled.p`
	display: block;
	font-size: 2rem;
	font-weight: 700;
	color: #222222;
`;

export const SuccessInfo = styled.p`
	display: block;
	font-size: 1rem;
	color: #909090;
`;

export const QRCodeBlock = styled.div`
  position: relative;

  .tick-sign, button {
    margin-top: -10px;
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    transform: translate(50%, -50%);
    width: 50%;
  }
`

export const BlurImage = styled.div`
  /* Add the blur effect */
  filter: blur(3px);
  -webkit-filter: blur(3px);
`

export const QRCode = styled.div`
  display: flex;
  justify-content: center;

  div {
    position: relative;
  }

  .scan-code__angle:before,
  .scan-code__angle:after {
    content: "";
    position: absolute;
    width: 60px;
    height: 60px;
    border-style: solid;
    border-color: black;
    border-width: 0;
    border-color: #6EB700;
  }

  .scan-code__angle:before {
    border-left-width: 6px;
    left: 0;
  }

  .scan-code__angle:after {
    border-right-width: 6px;
    right: 0;
  }

  .scan-code__angle--top:before,
  .scan-code__angle--top:after {
    top: 0;
    border-top-width: 6px;
  }

  .scan-code__angle--bottom:before,
  .scan-code__angle--bottom:after {
    bottom: 0;
    border-bottom-width: 6px;
  }

  .scan-code__angle--top:before {
    border-top-left-radius: 12px;
    margin-top: -4px;
    margin-left: -4px;
  }

  .scan-code__angle--top:after {
    border-top-right-radius: 12px;
    margin-top: -4px;
    margin-right: -4px;
  }

  .scan-code__angle--bottom:before {
    border-bottom-left-radius: 12px;
    margin-bottom: 4px;
    margin-left: -4px;
  }

  .scan-code__angle--bottom:after {
    border-bottom-right-radius: 12px;
    margin-bottom: 4px;
    margin-right: -4px;
  }
`

export const ShowPassword = styled.div`
  color: ${themeGet("colors.primary", "#9cc54b")};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 4%;
  cursor: pointer;

  &.express {
    color: #f01266;
  }
`;
